import {Dispatch} from 'redux';
import {ThunkAction} from 'redux-thunk';

import * as types from './types';
import {StatusMessageAction, StatusMessageState} from '../_reducers/statusMessage';
import {StatusMessage} from '../types';

type ThunkResult<R> = ThunkAction<R, StatusMessageState, undefined, StatusMessageAction>

export function postStatusMessageWithTimeout(message: StatusMessage | null, timeout: number): ThunkResult<void> {
    console.log('dispatching', message);
    return (dispatch: Dispatch) => {
        dispatch(setStatusMessage(message));

        return new Promise(function (resolve) {
            setTimeout(function () {
                resolve();
            }, timeout);
        }).then(() => {
            dispatch(clearStatusMessage());
        });
    };
}

export function setStatusMessage(message: StatusMessage | null): StatusMessageAction {
    return {type: types.STATUS_MESSAGE_SET, message}
}

export function clearStatusMessage() {
    return {type: types.STATUS_MESSAGE_CLEAR};
}
